export const startExistFunction = (fn, delay = 1000, selectorId) => {
    if (!window[fn] || (selectorId && !document.getElementById(selectorId))) {
        setTimeout(() => {
            startExistFunction(fn, delay);
        }, delay);

        return;
    }

    window[fn]?.();
};
